import { gsap } from 'gsap';

/**
 * Testimonials slider — handles all .ul-testimonials instances on a page.
 *
 * Each instance is self-contained: prev/next arrows advance the current index,
 * dot buttons jump directly to a slide. GSAP cross-fades the quote text.
 */

// Testimonial data — shared across all pages.
// Add or remove entries here; the dot count updates automatically.
const TESTIMONIALS = [
  {
    quote:  '"The staff at Legacy Heights have gone above and beyond for our mother. From the moment we walked in, we felt the warmth and genuine care that defines this community. We know she is safe, loved, and living her best life here."',
    author: 'Family Member',
  },
  {
    quote:  '"Moving to Legacy Heights was the best decision we made for our father. The team treats every resident like family, and the quality of care is exceptional. He is thriving here."',
    author: 'Family Member',
  },
  {
    quote:  '"From the welcoming staff to the beautifully maintained spaces, Legacy Heights exceeded every expectation. Our grandmother is comfortable, engaged, and genuinely happy."',
    author: 'Family Member',
  },
  {
    quote:  '"We toured several communities before choosing Legacy Heights. The difference was immediate — the atmosphere, the attentiveness of the team, and the warmth of the residents spoke for themselves."',
    author: 'Family Member',
  },
  {
    quote:  '"Legacy Heights has given our family peace of mind we didn\'t know we were missing. Knowing our mother is safe, cared for, and enjoying her days means everything."',
    author: 'Family Member',
  },
];

function initSlider( container ) {
  const quoteEl  = container.querySelector( '.ul-testimonials__quote' );
  const authorEl = container.querySelector( '.ul-testimonials__author' );
  const dotsWrap = container.querySelector( '.ul-testimonials__dots' );
  const prevBtn  = container.querySelector( '.ul-testimonials__arrow[aria-label="Previous testimonial"]' );
  const nextBtn  = container.querySelector( '.ul-testimonials__arrow[aria-label="Next testimonial"]' );

  if ( ! quoteEl || ! dotsWrap ) return;

  const total = TESTIMONIALS.length;
  let current = 0;

  // Build dots to match testimonial count (HTML may have fewer/more)
  dotsWrap.innerHTML = TESTIMONIALS.map( ( _, i ) => `
    <button
      class="ul-testimonials__dot${i === 0 ? ' ul-testimonials__dot--active' : ''}"
      role="tab"
      aria-selected="${i === 0 ? 'true' : 'false'}"
      aria-label="Testimonial ${i + 1}"
    ></button>
  ` ).join( '' );

  const dots = dotsWrap.querySelectorAll( '.ul-testimonials__dot' );

  function goTo( index ) {
    if ( index === current ) return;

    const tl = gsap.timeline();
    tl.to( [ quoteEl, authorEl ], {
      opacity: 0,
      y: -8,
      duration: 0.2,
      ease: 'power2.in',
      onComplete() {
        current = ( index + total ) % total;
        quoteEl.textContent  = TESTIMONIALS[ current ].quote;
        if ( authorEl ) authorEl.textContent = TESTIMONIALS[ current ].author;

        dots.forEach( ( dot, i ) => {
          dot.classList.toggle( 'ul-testimonials__dot--active', i === current );
          dot.setAttribute( 'aria-selected', i === current ? 'true' : 'false' );
        } );
      },
    } ).to( [ quoteEl, authorEl ], {
      opacity: 1,
      y: 0,
      duration: 0.3,
      ease: 'power2.out',
    } );
  }

  if ( prevBtn ) prevBtn.addEventListener( 'click', () => goTo( current - 1 ) );
  if ( nextBtn ) nextBtn.addEventListener( 'click', () => goTo( current + 1 ) );

  dots.forEach( ( dot, i ) => {
    dot.addEventListener( 'click', () => goTo( i ) );
  } );
}

export function initTestimonials() {
  document.querySelectorAll( '.ul-testimonials' ).forEach( initSlider );
}
